import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(theme => ({
	root: {
		position: 'fixed',
		right: 24,
		bottom: 24,
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
		zIndex: 1400,
		maxWidth: 340,
		[theme.breakpoints.down('xs')]: {
			right: 12,
			bottom: 12,
			maxWidth: 'calc(100vw - 24px)'
		}
	},
	item: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		padding: theme.spacing(1.25, 1.5),
		borderRadius: 10,
		background: theme.palette.background.paper,
		boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
		border: `1px solid ${theme.palette.divider}`,
		minWidth: 260
	},
	iconCol: {
		width: 28,
		height: 28,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0
	},
	textCol: {
		flex: 1,
		minWidth: 0
	},
	primary: {
		fontSize: 13,
		fontWeight: 600,
		color: theme.palette.text.primary,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	secondary: {
		fontSize: 12,
		color: theme.palette.text.secondary,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	successText: { color: '#16a34a' },
	errorText: { color: '#dc2626' },
	closeBtn: {
		padding: 4,
		color: theme.palette.text.secondary
	}
}));

function UploadSnackbar({ uploads, onDismiss }) {
	const classes = useStyles();
	if (!uploads || !uploads.length) return null;

	const renderIcon = u => {
		if (u.status === 'success') return <CheckCircleIcon style={{ color: '#16a34a' }} />;
		if (u.status === 'error') return <ErrorOutlineIcon style={{ color: '#dc2626' }} />;
		return <CircularProgress size={20} thickness={5} style={{ color: '#1877F2' }} />;
	};

	const renderSecondary = u => {
		if (u.status === 'success') {
			return <span className={classes.successText}>{u.successLabel || 'Done'}</span>;
		}
		if (u.status === 'error') {
			return <span className={classes.errorText}>{u.error || 'Upload failed'}</span>;
		}
		return <span>Uploading… you can keep working.</span>;
	};

	return (
		<div className={classes.root}>
			{uploads.map(u => (
				<div key={u.id} className={classes.item}>
					<div className={classes.iconCol}>{renderIcon(u)}</div>
					<div className={classes.textCol}>
						<div className={classes.primary}>{u.label}</div>
						<div className={classes.secondary}>{renderSecondary(u)}</div>
					</div>
					{(u.status === 'success' || u.status === 'error') && (
						<IconButton
							size="small"
							className={classes.closeBtn}
							onClick={() => onDismiss && onDismiss(u.id)}
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					)}
				</div>
			))}
		</div>
	);
}

export default UploadSnackbar;
